/*
 * United4x4 addition: estimated delivery date range for the product page.
 * Reads handling/delivery-day settings from data-* attributes (set in
 * sections/main-product.liquid from the "Estimated delivery date" block's
 * theme-editor settings) and computes a date range in Australia/Perth time,
 * skipping weekends. This is independent of Shopify's actual shipping
 * profile settings, which Liquid cannot read.
 */
(function () {
  function getPerthParts(date) {
    var fmt = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Perth',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false
    });
    var parts = {};
    fmt.formatToParts(date).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return parts;
  }

  function perthDateOnly(date) {
    var p = getPerthParts(date);
    return new Date(Date.UTC(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10)));
  }

  function addBusinessDays(startDate, days) {
    var result = new Date(startDate.getTime());
    var added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      var day = result.getUTCDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  }

  function renderEstimate(el) {
    var textEl = el.querySelector('[data-delivery-estimate-text]');
    if (!textEl) return;

    var handlingMin = parseInt(el.dataset.handlingMin, 10);
    var handlingMax = parseInt(el.dataset.handlingMax, 10);
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    var deliveryMin = parseInt(el.dataset.deliveryMin, 10);
    var deliveryMax = parseInt(el.dataset.deliveryMax, 10);

    if (isNaN(handlingMin)) handlingMin = 0;
    if (isNaN(handlingMax)) handlingMax = 1;
    if (isNaN(cutoffHour)) cutoffHour = 10;
    if (isNaN(deliveryMin)) deliveryMin = 5;
    if (isNaN(deliveryMax)) deliveryMax = 9;

    var now = new Date();
    var perthHour = parseInt(getPerthParts(now).hour, 10);
    var pastCutoff = perthHour >= cutoffHour;

    if (pastCutoff) {
      handlingMin += 1;
      handlingMax += 1;
    }

    var today = perthDateOnly(now);
    var minDate = addBusinessDays(today, handlingMin + deliveryMin);
    var maxDate = addBusinessDays(today, handlingMax + deliveryMax);

    textEl.textContent = formatDate(minDate) + ' – ' + formatDate(maxDate);
  }

  function init() {
    var elements = document.querySelectorAll('.product-delivery-estimate');
    elements.forEach(renderEstimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
